/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChineseOrderBatchOutboundReqVo
 */
export interface ChineseOrderBatchOutboundReqVo {
    /**
     * 订单ID列表
     * @type {Array<number>}
     * @memberof ChineseOrderBatchOutboundReqVo
     */
    orderIds?: Array<number>;
    /**
     * 是否在出库计划中：1=出库计划确认出库，0=转单到韩国
     * @type {number}
     * @memberof ChineseOrderBatchOutboundReqVo
     */
    inOutboundPlan?: number;
}

/**
 * Check if a given object implements the ChineseOrderBatchOutboundReqVo interface.
 */
export function instanceOfChineseOrderBatchOutboundReqVo(value: object): value is ChineseOrderBatchOutboundReqVo {
    return true;
}

export function ChineseOrderBatchOutboundReqVoFromJSON(json: any): ChineseOrderBatchOutboundReqVo {
    return ChineseOrderBatchOutboundReqVoFromJSONTyped(json, false);
}

export function ChineseOrderBatchOutboundReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChineseOrderBatchOutboundReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
        'inOutboundPlan': json['inOutboundPlan'] == null ? undefined : json['inOutboundPlan'],
    };
}

export function ChineseOrderBatchOutboundReqVoToJSON(json: any): ChineseOrderBatchOutboundReqVo {
    return ChineseOrderBatchOutboundReqVoToJSONTyped(json, false);
}

export function ChineseOrderBatchOutboundReqVoToJSONTyped(value?: ChineseOrderBatchOutboundReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderIds': value['orderIds'],
        'inOutboundPlan': value['inOutboundPlan'],
    };
}

